export default "__VITE_ASSET__85f0bd31__"